<template>
  <div class="">
    <div class="mb-6 -mt-4 text-xl text-center " v-if="menu">
      {{ get(menu.translations, $store.state.locale, "name") }}
      <h3 class="text-base text-gray-600">
        {{ get(menu.translations, $store.state.locale, "description") }}
      </h3>
    </div>
    <ul class="space-y-6">
      <li v-for="(source, indexcat) in categories" :key="source.id">
        <div class="flex items-center m-2">
          <img
            v-if="source.icon != null && showicon"
            :src="getCategoryIcon(source.icon)"
            class="inline-block w-5 h-5"
            :alt="source.name"
          />
          <h3 class="ml-2 text-lg font-medium leading-6 text-gray-900">
            {{ get(source.translations, $store.state.locale, "name") }}
          </h3>
        </div>
        <ul
          class="grid-cols-2 gap-4 overflow-hidden bg-white divide-y divide-gray-200 rounded-md shadow md:overflow-visible md:shadow-none md:rounded-none md:bg-transparent md:grid"
        >
          <li
            v-for="(dish, indexdish) in source.dishes"
            :key="dish.id"
            class="bg-white md:shadow"
          >
            <div
              class="block transition duration-150 ease-in-out focus:outline-none focus:bg-gray-50"
            >
              <div class="flex items-center px-4 py-4 sm:px-6">
                <div class="flex items-center flex-1 min-w-0">
                  <div class="flex-1 min-w-0 md:grid md:grid-cols-1 md:gap-4">
                    <div>
                      <div
                        v-if="dish.image != null && showimage"
                        class="relative inline-block w-full mb-4 overflow-hidden rounded-md shadow-lg"
                        style="padding-bottom:56.25%"
                      >
                        <picture>
                          <source
                            :srcset="getDishImage(dish.image) + '.webp'"
                            type="image/webp"
                          />
                          <source
                            :srcset="getDishImage(dish.image) + '.jpg'"
                            type="image/jpeg"
                          />
                          <img
                            loading="lazy"
                            :src="getDishImage(dish.image) + '.jpg'"
                            class="absolute object-cover w-full max-h-full"
                          />
                        </picture>
                      </div>

                      <div class="flex justify-between">
                        <div
                          class="text-base font-medium leading-5"
                          :class="'text-' + $store.state.color.primary"
                        >
                          {{ setDishOrder(dish, indexcat, indexdish) }}

                          {{
                            get(dish.translations, $store.state.locale, "name")
                          }}
                        </div>
                        <div>
                          <button @click="addProductToCart({ dish, menu })">
                            <svg
                              class="w-6 h-6 fill-current "
                              :class="'text-' + $store.state.color.primary"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                            >
                              <path
                                d="M256 0C114.833 0 0 114.833 0 256s114.833 256 256 256 256-114.853 256-256S397.167 0 256 0zm0 472.341c-119.275 0-216.341-97.046-216.341-216.341S136.725 39.659 256 39.659 472.341 136.705 472.341 256 375.295 472.341 256 472.341z"
                              />
                              <path
                                d="M355.148 234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83 8.884-19.83 19.83v79.318h-79.318c-10.966 0-19.83 8.884-19.83 19.83s8.864 19.83 19.83 19.83h79.318v79.318c0 10.946 8.864 19.83 19.83 19.83s19.83-8.884 19.83-19.83v-79.318h79.318c10.966 0 19.83-8.884 19.83-19.83s-8.864-19.83-19.83-19.83z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                      <p class="mt-2 text-sm">
                        {{
                          get(
                            dish.translations,
                            $store.state.locale,
                            "description"
                          )
                        }}
                      </p>

                      <div class="flex">
                        <div class="w-1/3 mt-2">
                          <p
                            class="inline-flex items-center px-2 text-xs font-medium leading-5 rounded-md"
                            :class="'text-' +
                                $store.state.color.primary +
                                ' bg-' +
                                $store.state.color.secondary
                            "
                            v-if="
                              dish.price != null &&
                                dish.price != undefined &&
                                dish.price != '' &&
                                menu.hide_price != null &&
                                  menu.hide_price != undefined &&
                                  menu.hide_price != 1
                            "
                          >
                            {{ dish.price.toFixed(2) }} {{ dish.unit }}
                          </p>
                        </div>

                        <div class="w-2/3 mt-2 text-right">
                          <div v-if="dish.checked_allergies != null">
                            <span
                              v-for="allergen in dish.checked_allergies"
                              :key="'dish_' + dish.id + '_' + allergen"
                            >
                              <v-popover class="inline-block">
                                <img
                                  :src="
                                    getIconAllergen(
                                      getAllergen(allergen).icon,
                                      locationIconStyle
                                    )
                                  "
                                  class="inline-block p-1 mr-1 w-7 h-7"
                                />

                                <template slot="popover">
                                  <span class="text-sm">{{
                                    get(
                                      getAllergen(allergen).translations,
                                      $store.state.locale,
                                      "name"
                                    )
                                  }}</span>
                                </template>
                              </v-popover>
                            </span>
                          </div>

                          <div v-if="dish.checked_attributes != null">
                            <span
                              v-for="attribute in dish.checked_attributes"
                              :key="'dish_' + dish.id + '_' + attribute"
                            >
                              <v-popover class="inline-block">
                                <img
                                  :src="
                                    getIconAttribute(
                                      getAttribute(attribute).icon,
                                      locationIconStyle
                                    )
                                  "
                                  class="inline-block p-1 mr-1 w-7 h-7"
                                />

                                <template slot="popover">
                                  <span class="text-sm">{{
                                    get(
                                      getAttribute(attribute).translations,
                                      $store.state.locale,
                                      "name"
                                    )
                                  }}</span>
                                </template>
                              </v-popover>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--
                <div  :class="indexdish === (cat.dishes.length-1) ? '' : 'border-t mx-3'"></div>
                -->
            </div>
          </li>
        </ul>
      </li>
      <!--
    <virtual-list
          :data-key="'id'"
          :data-sources="categories"
          :data-component="itemComponent"
        ></virtual-list>
        -->
      <!--
        <li v-for="(cat, index) in categories" :key="cat.id"  :class="index > 0 ? 'mt-8' : ''" >
          <h3 class="text-lg font-medium leading-6 text-gray-900">{{cat.name}}</h3>
          <ul class="mt-3 overflow-hidden rounded-lg shadow">
            <li v-for="(dish) in cat.dishes" :key="dish.id" class="bg-white ">

              
              <div class="block transition duration-150 ease-in-out focus:outline-none focus:bg-gray-50">
                <div class="flex items-center px-4 py-4 sm:px-6">
                  <div class="flex items-center flex-1 min-w-0">

                    <div class="flex-1 min-w-0 md:grid md:grid-cols-2 md:gap-4">
                      <div>
                        <div class="flex justify-between">
                        <div class="text-base font-medium leading-5" :class="'text-'+$store.state.color.primary">
                          {{ get(dish.translations, $store.state.locale, 'name')}}
                        </div>
                        <div>
                          <button @click="addProductToCart(dish)">
                              <svg class="w-5 h-5 fill-current " :class="'text-'+$store.state.color.primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path d="M256 0C114.833 0 0 114.833 0 256s114.833 256 256 256 256-114.853 256-256S397.167 0 256 0zm0 472.341c-119.275 0-216.341-97.046-216.341-216.341S136.725 39.659 256 39.659 472.341 136.705 472.341 256 375.295 472.341 256 472.341z"/>
                                <path d="M355.148 234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83 8.884-19.83 19.83v79.318h-79.318c-10.966 0-19.83 8.884-19.83 19.83s8.864 19.83 19.83 19.83h79.318v79.318c0 10.946 8.864 19.83 19.83 19.83s19.83-8.884 19.83-19.83v-79.318h79.318c10.966 0 19.83-8.884 19.83-19.83s-8.864-19.83-19.83-19.83z"/>
                              </svg>
                          </button>
                        </div>
                        </div>
                        <p class="mt-2 text-sm">
                          {{ get(dish.translations, $store.state.locale, 'description')}}
                        </p>
                        
                        <div class="flex">
                          <div class="w-1/3 mt-2">
                            <p 
                            class="inline-flex items-center px-2 text-xs font-medium leading-5 rounded-md"
                            :class="'text-' + $store.state.color.primary+' bg-' + $store.state.color.secondary" 
                            v-if="dish.price">
                              {{ dish.price }} {{ dish.unit }}
                            </p>
                          </div>

                          <div class="w-2/3 mt-2 text-right">
                              <div>
                              <span v-for="(allergen, indexall) in dish.checked_allergies" :key="'dish_'+indexdish+'_all_'+indexall">
                                <v-popover class="inline-block">

                                  <img :src="'https://static.menubyte.it/icons/allergens/'+ getAllergen(allergen).icon+'.svg'" 
                                  class="inline-block p-1 mr-1 w-7 h-7">

                                  <template slot="popover" >
                                      <span class="text-sm">{{get(getAllergen(allergen).translations, $store.state.locale, 'name')}}</span>
                                  </template>
                                  
                                </v-popover>                                
                              </span>
                              </div>
                          
                              <div>
                              <span v-for="(attribute, indexattr) in dish.checked_attributes" :key="'dish_'+indexattr+'_att_'+indexattr">
                                <v-popover class="inline-block">


                                  <img :src="'https://static.menubyte.it/icons/attributes/'+ getAttribute(attribute).icon+'.svg'" 
                                  class="inline-block p-1 mr-1 w-7 h-7">

                                  <template slot="popover" >
                                      <span class="text-sm">{{get(getAttribute(attribute).translations, $store.state.locale, 'name')}}</span>
                                  </template>
                                
                                </v-popover>                                
                              </span>


                              </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div  :class="indexdish === (cat.dishes.length-1) ? '' : 'border-t mx-3'"></div>
              </div>
              
            </li>
           
          </ul>

        </li>
 -->
    </ul>
  </div>
</template>

<script>
import Translations from "../../../apis/Translations";
//import VirtualList from 'vue-virtual-scroll-list'
import { mapActions } from "vuex";
import Item from "./ItemComponent";
import IconService from "../../../apis/IconService";

export default {
  props: {
    idmenu: Number,
  },
  /*
  components: { 
    "virtual-list": VirtualList 
  },
  */
  data() {
    return {
      dishes: [],
      categories: [],
      tempallergen: null,
      itemComponent: Item,
      locationIconStyle: 1,
      menu: null,
    };
  },
  mounted() {
    this.$store.dispatch("updateSpinner", true);

    this.load();

    if (
      ((this.$store.state.location.menuRestaurantCount > 0 &&
        this.$store.state.location.menuHotelCount > 0) ||
        (this.$store.state.location.menuRestaurantCount == 0 &&
          this.$store.state.location.menuHotelCount -
            this.$store.state.location.menuRoomServiceCount >
            0 &&
          this.$store.state.location.menuRoomServiceCount > 0)) &&
      this.$store.state.userShowMenuHotel == -1
    ) {
      console.log("--->" + this.$store.state.userShowMenuHotel);

      this.$router.push("/" + this.$store.state.location.uuid);
    }

    /*
    userShowMenuHotel
    -1 nessuna scelta
    1 scelto holte
    0 scelto ristorante
    */
    /*
   non si sa l'esistenza del codice sotto?
    if (
      this.$store.state.userShowMenuHotel != 1 &&
      this.$store.state.location.menuRestaurantCount == 0 &&
      this.$store.state.location.menuHotelCount > 0
    ) {
      this.$store.dispatch("setUserShowMwnu", 1);
    }
    */
  },
  computed: {
    showimage() {
      return this.$store.state.location.extra.showimage;
    },
    showicon() {
      return this.$store.state.location.extra.showicon;
    },
  },
  methods: {
    ...mapActions("cart", ["addProductToCart"]),
    getCategoryByid(idcat) {
      let r = this.$store.state.location.categories.filter(
        (x) => x.id == idcat
      );
      return JSON.parse(JSON.stringify(r));
    },
    setDishOrder(dish, indexcat, indexdish) {
      dish.incremental = indexcat * 1000 + indexdish;
    },
    getCategoryIcon: function(url) {
      return IconService.getIconCat(url);
    },
    getDishImage: function(url) {
      return IconService.getDishImage(url);
    },
    getIconAttribute: function(iconid, styleid) {
      return IconService.getIconAttribute(iconid, styleid);
    },

    getIconAllergen: function(iconid, styleid) {
      return IconService.getIconAllergen(iconid, styleid);
    },

    getDishes() {
      let r = this.$store.state.location.dishes_menus.filter(
        (x) => x.id == this.idmenu
      );
      if (r.length > 0) {
        return r[0].dishes;
      }
    },
    getMenu() {
      let r = this.$store.state.location.menus.filter(
        (x) => x.id == this.idmenu
      );
      if (r.length > 0) {
        return r[0];
      }
    },
    /*
    getAllergen(idall){
      let r = this.$store.state.location.allergies.filter(x => x.id == idall);
      if (r.length > 0){
        return r[0];
      }
    },
    getAttribute(idattr){
      let r = this.$store.state.location.attributes.filter(x => x.id == idattr);
      if (r.length > 0){
        return r[0];
      }
    },
    get: function(translations, locale, prop){
      return Translations.get(translations, locale, prop);
    }
*/
    get: function(translations, locale, prop) {
      return Translations.get(translations, locale, prop);
    },

    getAllergen: function(allergen_id) {
      let r = this.$store.state.location.allergies.filter(
        (x) => x.id == allergen_id
      );
      if (r.length > 0) {
        return r[0];
      }
    },

    getAttribute: function(attribute_id) {
      let r = this.$store.state.location.attributes.filter(
        (x) => x.id == attribute_id
      );
      if (r.length > 0) {
        return r[0];
      }
    },

    async load() {
      this.categories = [];
      this.dishes = [];
      this.menu = this.getMenu();
      this.dishes = this.getDishes();

      this.locationIconStyle = this.$store.state.location.icon_style_id;

      let currentCat = -1;
      // eslint-disable-next-line no-unused-vars
      let catIndex = -1;
      if (this.dishes != null) {
        for (let i = 0; i < this.dishes.length; i++) {
          let dish = this.dishes[i];

          if (currentCat != dish.dish_category_id) {
            let cat = this.getCategoryByid(dish.dish_category_id)[0];
            currentCat = dish.dish_category_id;
            catIndex++;
            this.categories.push(cat);
          }

          if (this.categories[catIndex].dishes == undefined) {
            this.categories[catIndex].dishes = [];
          }

          this.categories[catIndex].dishes.push(dish);
        }
      }

      this.$store.dispatch("updateSpinner", false);
    },
  },
};
</script>
